module.exports = "//public.zight.com/packs/media/images/annotate/highlighter-93a2dd4cc2fb7cbdbe3a7008b07a08cd.svg";